import React from 'react';

import { Box, Typography } from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot, faCheck } from '@fortawesome/free-solid-svg-icons';

export const getPasswordStrength = password => {
  const min = password.length >= 8;
  const uppercase = /^(?=.*[A-Z]).+$/.test(password);
  const lowercase = /^(?=.*[a-z]).+$/.test(password);
  const number = /^(?=.*\d).+$/.test(password);

  const matchedRequirementsNumber = [min, uppercase, lowercase, number].filter(requirement => !!requirement).length;

  if(matchedRequirementsNumber == 1) {
    return (
      <>
        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', height: 5, borderRadius: 5 }}>
          <Box style={{ width: '33%', height: 5, backgroundColor: '#D1463F', borderRadius: 5 }} />
          <Box style={{ width: '67%', height: 5, backgroundColor: '#F4F4F6', borderRadius: 5 }} />
        </Box>
        <Box style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant='body2' color='textSecondary'>
            Força da senha
          </Typography>
          <Typography variant='body2' style={{ color: '#D1463F' }}>
            Fraca
          </Typography>
        </Box>
      </>
    );
  }

  if(matchedRequirementsNumber == 2 || matchedRequirementsNumber == 3) {
    return (
      <>
        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', height: 5, borderRadius: 5 }}>
          <Box style={{ width: '67%', height: 5, backgroundColor: '#E48437', borderRadius: 5 }} />
          <Box style={{ width: '33%', height: 5, backgroundColor: '#F4F4F6', borderRadius: 5 }} />
        </Box>
        <Box style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant='body2' color='textSecondary'>
            Força da senha
          </Typography>
          <Typography variant='body2' style={{ color: '#E48437' }}>
            Média
          </Typography>
        </Box>
      </>
    );
  }

  if(matchedRequirementsNumber >= 4) {
    return (
      <>
        <Box style={{ width: '100%', height: 5, backgroundColor: '#53AC5D', borderRadius: 5 }} />
        <Box style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant='body2' color='textSecondary'>
            Força da senha
          </Typography>
          <Typography variant='body2' style={{ color: '#53AC5D' }}>
            Forte
          </Typography>
        </Box>
      </>
    );
  }

  return(
    <>
      <Box style={{ width: '100%', height: 5, backgroundColor: '#F4F4F6', borderRadius: 5 }} />
      <Box style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant='body2' color='textSecondary'>
          Força da senha
        </Typography>
        <Typography variant='body2' color='textSecondary'>
          ---
        </Typography>
      </Box>
    </>
  );
}

export const getPasswordRules = password => {
  return(
    <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 5, backgroundColor: '#F9FAFC', border: '1px solid #EDF0F5', borderRadius: 8, padding: 10 }}>
      <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 25, height: 25, borderRadius: '50%', backgroundColor: password.length < 8 ? '#F4F4F6' : '#EDFBF1' }}>
          <FontAwesomeIcon
            color={password.length < 8 ? '#6C727F' : '#53AC5D'}
            size='sm'
            icon={password.length < 8 ? faCircleDot : faCheck}
          />
        </Box>
        <Typography variant='body2' style={{ color: password.length < 8 ? '#757575' : '#53AC5D' }}>
          Mínimo de 8 caracteres
        </Typography>
      </Box>
      <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 25, height: 25, borderRadius: '50%', backgroundColor: !/^(?=.*[A-Z]).+$/.test(password) ? '#F4F4F6' : '#EDFBF1' }}>
          <FontAwesomeIcon
            color={!/^(?=.*[A-Z]).+$/.test(password) ? '#6C727F' : '#53AC5D'}
            size='sm'
            icon={!/^(?=.*[A-Z]).+$/.test(password) ? faCircleDot : faCheck}
          />
        </Box>
        <Typography variant='body2' style={{ color: !/^(?=.*[A-Z]).+$/.test(password) ? '#757575' : '#53AC5D' }}>
          Pelo menos 1 letra maiúscula (A-Z)
        </Typography>
      </Box>
      <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 25, height: 25, borderRadius: '50%', backgroundColor: !/^(?=.*[a-z]).+$/.test(password) ? '#F4F4F6' : '#EDFBF1' }}>
          <FontAwesomeIcon
            color={!/^(?=.*[a-z]).+$/.test(password) ? '#6C727F' : '#53AC5D'}
            size='sm'
            icon={!/^(?=.*[a-z]).+$/.test(password) ? faCircleDot : faCheck}
          />
        </Box>
        <Typography variant='body2' style={{ color: !/^(?=.*[a-z]).+$/.test(password) ? '#757575' : '#53AC5D' }}>
          Pelo menos 1 letra minúscula (a-z)
        </Typography>
      </Box>
      <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 25, height: 25, borderRadius: '50%', backgroundColor: !/^(?=.*\d).+$/.test(password) ? '#F4F4F6' : '#EDFBF1' }}>
          <FontAwesomeIcon
            color={!/^(?=.*\d).+$/.test(password) ? '#6C727F' : '#53AC5D'}
            size='sm'
            icon={!/^(?=.*\d).+$/.test(password) ? faCircleDot : faCheck}
          />
        </Box>
        <Typography variant='body2' style={{ color: !/^(?=.*\d).+$/.test(password) ? '#757575' : '#53AC5D' }}>
          Pelo menos 1 número (0-9)
        </Typography>
      </Box>
      <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 25, height: 25, borderRadius: '50%', backgroundColor: !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password) ? '#F4F4F6' : '#EDFBF1' }}>
          <FontAwesomeIcon
            color={!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password) ? '#6C727F' : '#53AC5D'}
            size='sm'
            icon={!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password) ? faCircleDot : faCheck}
          />
        </Box>
        <Typography variant='body2' style={{ color: !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password) ? '#757575' : '#53AC5D' }}>
          Pelo menos 1 caractere especial
        </Typography>
      </Box>
    </Box>
  );
}